import type { FunctionComponent } from "react";

import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";
import { useHomepageLogoLinkProps } from "scmp-app/components/header/hooks";

import { Container, StyledLogoLink, StyledScmpStyleLogoFlag } from "./styles";

export type HeaderFeaturesStyleLogoLinkProps = HeaderFeatureCommonProps;

export const HeaderFeaturesStyleLogoLink: FunctionComponent<HeaderFeaturesStyleLogoLinkProps> = ({
  ...props
}) => {
  const homepageLogoLinkProps = useHomepageLogoLinkProps();

  return (
    <Container {...getResponsiveProps(props)}>
      <StyledLogoLink {...homepageLogoLinkProps}>
        <StyledScmpStyleLogoFlag />
      </StyledLogoLink>
    </Container>
  );
};

HeaderFeaturesStyleLogoLink.displayName = "HeaderFeaturesStyleLogoLink";
